import { Avatar } from 'antd';
import React from 'react'

const colors = ["#A0D274", "#0B63AF", "#F78D0A", "#43A7A0", "#4B32C3", "#2684FF", "#F76F13", "#154983", "#F9D23F"]

export default function NameAvatar({ icon, name = "", color, ...props }) {
    const initials = name.replace(/\s+/g, " ").trim().split(" ").map((n)=>n[0]).join("") ?? ""
    
    props = {
        ...props,
        [typeof icon === 'string' ? 'src' : 'icon']: icon
    };
    const backgroundColor = props.src ? "" : (color || colors[Math.round((initials.toUpperCase().charCodeAt(0) - 65) / colors.length)]);
    return (
        <Avatar name={name} {...props} style={{ backgroundColor, ...props.style }} >{!icon && initials}</Avatar>
    )
}
